export type ColorSetting = "default";

export type Name =
  | "staff_years_of_service_less_than_1_count"
  | "staff_years_of_service_1_to_2_count"
  | "staff_years_of_service_3_to_4_count"
  | "staff_years_of_service_5_to_9_count"
  | "staff_years_of_service_10_or_more_count"
  | "staff_employments_type_regular_members_count"
  | "staff_employments_type_arbeit_count"
  | "staff_employments_type_business_consignment_count"
  | "staff_employments_type_contract_employee_count"
  | "staff_employments_type_other_count";

type BackgroundColors = Record<ColorSetting, Record<Name, string>>;

type BorderColor = Record<ColorSetting, string>;

const PIE_CHART_COLOR_CODE_YELLOW = "#FCF7AA";
const PIE_CHART_COLOR_CODE_ORANGE = "#FFCE93";
const PIE_CHART_COLOR_CODE_GREEN = "#CCF3C4";
const PIE_CHART_COLOR_CODE_BLUE = "#B2DEF8";
const PIE_CHART_COLOR_CODE_RED = "#FFC0BF";

export const backgroundColors: BackgroundColors = {
  default: {
    // 勤続年数
    staff_years_of_service_less_than_1_count: PIE_CHART_COLOR_CODE_YELLOW,
    staff_years_of_service_1_to_2_count: PIE_CHART_COLOR_CODE_ORANGE,
    staff_years_of_service_3_to_4_count: PIE_CHART_COLOR_CODE_GREEN,
    staff_years_of_service_5_to_9_count: PIE_CHART_COLOR_CODE_BLUE,
    staff_years_of_service_10_or_more_count: PIE_CHART_COLOR_CODE_RED,
    // 雇用形態
    staff_employments_type_regular_members_count: PIE_CHART_COLOR_CODE_YELLOW,
    staff_employments_type_arbeit_count: PIE_CHART_COLOR_CODE_ORANGE,
    staff_employments_type_business_consignment_count: PIE_CHART_COLOR_CODE_GREEN,
    staff_employments_type_contract_employee_count: PIE_CHART_COLOR_CODE_BLUE,
    staff_employments_type_other_count: PIE_CHART_COLOR_CODE_RED,
  },
};

export const borderColor: BorderColor = {
  default: "#fff",
};
